import { TITLES } from './title';

export const PATH = {
  CLIENT: '/configuration/clients',

  CLIENT_DETAIL: '/configuration/clients/details',

  BROKER_DETAIL: '/configuration/brokers/details',

  TRADERS: '/configuration/traders',

  SECURITIES_DICTIONARY: '/configuration/securities',

  PRODUCT_DICTIONARY_DETAIL: '/configuration/product/detail',

  EXCHANGE: '/configuration/exchanges',

  CLIENT_GROUPS: '/configuration/client-groups',

  CREATE_CLIENT: '/configuration/create-client',

  CREATE_BROKER: '/configuration/create-broker',

  CLIENT_UNIT_SIZE: '/configuration/client-unit-size',

  CUSTODY_DATA: '/custody-data',
  CUSTODY_DATA_CASH: '/custody-data/cash',
  CUSTODY_DATA_CONFIGURATION: '/custody-data/configuration',
  CUSTODY_DATA_CONFIGURATION_MANUAL: '/custody-data/configuration/manual',
  CUSTODY_IMPORT_FILE: '/file-management/custody-import-files',
  CUSTODY_DATA_POSITIONS: '/custody-data/positions',
  CUSTODY_DATA_RUN: '/custody-data/run',
  CUSTODY_DATA_TRANSACTIONS: '/custody-data/transactions',

  EXTERNAL_CONTACTS: '/tools/external-contact',

  REPORT_SALES_TRADING: '/reports/sales-trading',

  REPORT_COMMISSION_REBATE: '/reports/commission-rebate',

  REPORT_STATEMENT: '/reports/statement',

  REPORT_PORTFOLIO_SUMMARY: '/reports/portfolio-summary',

  REPORT_TRANSACTION: '/reports/transaction',

  REPORT_DAILY_EXPOSURE: '/reports/daily-exposure',

  REPORT_TURNOVER_BY_REGION: '/reports/turnover-by-region',

  REPORT_FACTSHEET: '/reports/create-factsheet',

  ICAV_REPORT: '/reports/icav-report',

  ARBOR: '/arbor',

  STRATEGY_PAIR: '/strategy/pair',

  TRADE_SEARCH: '/trade/search',

  TRADE_DETAIL: '/trade/detail',

  CORPORATE_ACTIONS: '/trade/corporate-actions',

  TRADE_CONFIRMATION: '/trade/confirmation',

  TRADE_ALLOCATION: '/trade/allocation',

  MARGIN_PROCESSING: '/trade/margin-processing',

  SETTLEMENT_HOLIDAY: '/configuration/settlement-holiday',

  FEES_BOOKING: '/trade/fees-booking',

  RECALCULATION: '/tools/recalculation',

  OPEN_POSITION: '/positions/open-position',

  TRADE_BLOTTER: '/positions/trade-blotter',

  REBALANCE: '/tools/rebalance',

  RECONCILIATION: '/reconciliation/reconciliation-page',

  IMPORT_FILE: '/file-management/import-files',

  MIFID: '/regulatory-reporting/mifid',

  PRICING: '/configuration/pricing-page',

  COUNTERPARTY_POSITIONS: '/reconciliation/counterparty-positions',

  UPLOADED_FILES: '/file-management/uploaded-files',

  ACGMarkup: '/reports/acg-markup',

  BROKERS: '/configuration/brokers',

  DOCUMENTATION: '/tools/documentation',

  MARKETS: '/configuration/markets',

  REGIONS: '/configuration/regions',

  ACCOUNT_SUMMARY: '/reports/account-summary',

  CHECK_QUANTITIES: '/regulatory-reporting/check-quantities',

  VIRTU: '/counterparties/virtu',

  GOLDMAN_SACHS: '/counterparties/goldman-sachs',

  FAILED_FIX_MESSAGES: '/tools/failed-fix-messages',

  TRADERS_PL: '/reports/traders-pl',

  REPORT_TIMELINE: '/reports/timeline',

  TECHNICAL_INDICATORS_RSI_PATTERN_RECOGNITION:
    '/technical-indicators/rsi-pattern-recognition',
  TECHNICAL_INDICATORS_RSI_HISTORY: '/technical-indicators/rsi-history',
  REPORT_PORTFOLIOS: '/reports/portfolios',
  REPORT_PORTFOLIO_DETAILS: '/reports/portfolios/details',

  //Portal and Admin

  DASHBOARD: '/',
  MAINTENANCE: '/maintenance',
  AUTH_LOGIN: '/auth/login',

  //Admin

  USER_MANAGEMENT_USERS: '/user-management/users',
  USER_MANAGEMENT_PERMISSIONS: '/user-management/permissions',
  USER_MANAGEMENT_GROUPS: '/user-management/groups',

  TOOLS_ACTIVITY_LOGS: '/tools/activity-logs',
  TOOLS_FAILED_FIX_MESSAGES: '/tools/failed-fix-messages',
  TOOLS_BACKUPS: '/tools/backups',
  TOOLS_FIX_AGGREGATION: '/tools/fix-aggregation',
  TOOLS_INSERT_FIX_MESSAGES: '/tools/insert-fix-messages',
  TOOLS_POSITIONS_RECALCULATION: '/tools/positions-recalculation',

  CONFIGURATION_PARAMETER: '/configuration/parameter',
  CONFIGURATION_PARAMETER_VALUE: '/configuration/parameter-value',
  CONFIGURATION_PARAMETER_VALUE_ID: '/configuration/parameter-value-id',
  CONFIGURATION_SETTLEMENT_CYCLES: '/configuration/settlement-cycles',

  FILE_MANAGEMENT_FILES_MAPPING: '/file-management/files-mapping',
  FILE_MANAGEMENT_SFTP: '/file-management/sftp',
  FILE_MANAGEMENT_SFTP_FILE_DETAILS: '/file-management/sftp-file-details',

  SYSTEM_CONSTANTS: '/system/constants',
  SYSTEM_MAINTENANCE: '/system/maintenance',

  NOTIFICATIONS: '/notifications',

  MAINTENANCE_PREVIEW: '/maintenance/preview',
};

export const PATH_TO_TITLE = {
  [PATH.UPLOADED_FILES]: TITLES.UPLOADED_FILES,
  [PATH.REPORT_STATEMENT]: TITLES.STATEMENT,
  [PATH.REPORT_PORTFOLIO_SUMMARY]: TITLES.PORTFOLIO_SUMMARY,
  [PATH.REPORT_TRANSACTION]: TITLES.TRANSACTION,
  [PATH.REPORT_DAILY_EXPOSURE]: TITLES.DAILY_EXPOSURE,
  [PATH.REPORT_COMMISSION_REBATE]: TITLES.COMMISSION_REBATE,
  [PATH.REPORT_SALES_TRADING]: TITLES.SALES_TRADING,
  [PATH.REPORT_TURNOVER_BY_REGION]: TITLES.TURNOVER_BY_REGION,
  [PATH.REPORT_FACTSHEET]: TITLES.FACTSHEET_CREATE,
  [PATH.ICAV_REPORT]: TITLES.ICAV_REPORT,
  [PATH.OPEN_POSITION]: TITLES.OPEN_POSITION,
  [PATH.TRADE_BLOTTER]: TITLES.TRADE_BLOTTER,
  [PATH.CLIENT]: TITLES.CLIENTS,
  [PATH.TRADERS]: TITLES.TRADERS,
  [PATH.MARKETS]: TITLES.MARKETS,
  [PATH.SECURITIES_DICTIONARY]: TITLES.SECURITIES_DICTIONARY,
  [PATH.EXCHANGE]: TITLES.EXCHANGES,
  [PATH.CLIENT_GROUPS]: TITLES.CLIENT_GROUPS,
  [PATH.CREATE_CLIENT]: TITLES.CREATE_CLIENT,
  [PATH.CREATE_BROKER]: TITLES.CREATE_BROKER,
  [PATH.PRICING]: TITLES.PRODUCT_PRICING,
  [PATH.CLIENT_UNIT_SIZE]: TITLES.CLIENT_UNIT_SIZE,
  [PATH.CUSTODY_DATA]: TITLES.CUSTODY_DATA,
  [PATH.CUSTODY_DATA_CASH]: TITLES.CUSTODY_DATA_CASH,
  [PATH.CUSTODY_DATA_CONFIGURATION]: TITLES.CUSTODY_DATA_CONFIGURATION,
  [PATH.CUSTODY_DATA_CONFIGURATION_MANUAL]:
    TITLES.CUSTODY_DATA_CONFIGURATION_MANUAL,
  [PATH.CUSTODY_IMPORT_FILE]: TITLES.CUSTODY_IMPORT_FILES,
  [PATH.CUSTODY_DATA_POSITIONS]: TITLES.CUSTODY_DATA_POSITIONS,
  [PATH.CUSTODY_DATA_RUN]: TITLES.CUSTODY_DATA_RUN,
  [PATH.CUSTODY_DATA_TRANSACTIONS]: TITLES.CUSTODY_DATA_TRANSACTIONS,
  [PATH.EXTERNAL_CONTACTS]: TITLES.EXTERNAL_CONTACTS,
  [PATH.TRADE_SEARCH]: TITLES.TRADE_SEARCH,
  [PATH.TRADE_DETAIL]: TITLES.TRADE_ENTRY,
  [PATH.CORPORATE_ACTIONS]: TITLES.TRADE_CORPORATE,
  [PATH.TRADE_CONFIRMATION]: TITLES.TRADE_CONFIRMATION,
  [PATH.TRADE_ALLOCATION]: TITLES.TRADE_ALLOCATION,
  [PATH.MARGIN_PROCESSING]: TITLES.TRADE_MARGINPROCESSING,
  [PATH.FEES_BOOKING]: TITLES.FEES_BOOKING,
  [PATH.IMPORT_FILE]: TITLES.IMPORT_FILES,
  [PATH.RECONCILIATION]: TITLES.RECONCILIATION,
  [PATH.COUNTERPARTY_POSITIONS]: TITLES.COUNTERPARTY_POSITIONS,
  [PATH.RECALCULATION]: TITLES.RECALCULATION,
  [PATH.SETTLEMENT_HOLIDAY]: TITLES.TRADE_HOLIDAY,
  [PATH.REBALANCE]: TITLES.REBALANCE,
  [PATH.ACGMarkup]: TITLES.ACGMarkup,
  [PATH.BROKERS]: TITLES.BROKERS,
  [PATH.MIFID]: TITLES.MIFID_II_FILE,
  [PATH.STRATEGY_PAIR]: TITLES.PAIR_TRADING,
  [PATH.DOCUMENTATION]: TITLES.DOCUMENTATION,
  [PATH.REGIONS]: TITLES.REGIONS,
  [PATH.ACCOUNT_SUMMARY]: TITLES.ACCOUNT_SUMMARY,
  [PATH.CHECK_QUANTITIES]: TITLES.CHECK_QUANTITIES,
  [PATH.VIRTU]: TITLES.VIRTU,
  [PATH.GOLDMAN_SACHS]: TITLES.GOLDMAN_SACHS,
  [PATH.TRADERS_PL]: TITLES.TRADERS_PL,
  [PATH.REPORT_TIMELINE]: TITLES.TIMELINE,
  [PATH.TECHNICAL_INDICATORS_RSI_PATTERN_RECOGNITION]:
    TITLES.RSI_PATTERN_RECOGNITION,
  [PATH.TECHNICAL_INDICATORS_RSI_HISTORY]: TITLES.RSI_HISTORY,
  [PATH.REPORT_PORTFOLIOS]: TITLES.PORTFOLIOS,
  //Both Portal and Admin
  [PATH.DASHBOARD]: TITLES.DASHBOARD,
  [PATH.AUTH_LOGIN]: TITLES.LOGIN,

  //Admin
  [PATH.USER_MANAGEMENT_USERS]: TITLES.USER_MANAGEMENT_USERS,
  [PATH.USER_MANAGEMENT_PERMISSIONS]: TITLES.USER_MANAGEMENT_PERMISSIONS,
  [PATH.USER_MANAGEMENT_GROUPS]: TITLES.USER_MANAGEMENT_GROUPS,

  [PATH.CONFIGURATION_PARAMETER]: TITLES.CONFIGURATION_PARAMETER,
  [PATH.CONFIGURATION_PARAMETER_VALUE_ID]:
    TITLES.CONFIGURATION_PARAMETER_VALUE_ID,

  [PATH.TOOLS_ACTIVITY_LOGS]: TITLES.TOOLS_ACTIVITY_LOGS,
  [PATH.TOOLS_FAILED_FIX_MESSAGES]: TITLES.TOOLS_FAILED_FIX_MESSAGES,
  [PATH.TOOLS_INSERT_FIX_MESSAGES]: TITLES.TOOLS_INSERT_FIX_MESSAGES,
  [PATH.TOOLS_FIX_AGGREGATION]: TITLES.TOOLS_FIX_AGGREGATION,
  [PATH.TOOLS_POSITIONS_RECALCULATION]: TITLES.TOOLS_POSITIONS_RECALCULATION,
  [PATH.FILE_MANAGEMENT_SFTP]: TITLES.FILE_MANAGEMENT_SFTP,

  [PATH.FILE_MANAGEMENT_FILES_MAPPING]: TITLES.FILE_MANAGEMENT_FILES_MAPPING,

  [PATH.SYSTEM_CONSTANTS]: TITLES.SYSTEM_CONSTANTS,
  [PATH.SYSTEM_MAINTENANCE]: TITLES.SYSTEM_MAINTENANCE,
  [PATH.CONFIGURATION_SETTLEMENT_CYCLES]:
    TITLES.CONFIGURATION_SETTLEMENT_CYCLES,

  [PATH.TOOLS_BACKUPS]: TITLES.TOOLS_BACKUPS,

  [PATH.NOTIFICATIONS]: TITLES.NOTIFICATIONS,
};
